import Routers from "./Route";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import WishListProvider from "./_helper/Ecommerce/Wishlist/WishlistProvider";
import ProductProvider from "./_helper/Ecommerce/Product/ProductProvider";
import FilterProvider from "./_helper/Ecommerce/Filter/FilterProvider";
import CartProvider from "./_helper/Ecommerce/Cart/CartProvider";
import { ToastContainer } from "react-toastify";

const App = () => {
  return (
    <>
      <AnimationThemeProvider>
        <CustomizerProvider>
          <CartProvider>
            <FilterProvider>
              <ProductProvider>
                <WishListProvider>
                  <Routers />
                </WishListProvider>
              </ProductProvider>
            </FilterProvider>
          </CartProvider>
        </CustomizerProvider>
      </AnimationThemeProvider>
      <ToastContainer />
    </>
  );
};
export default App;
